import {atom} from "recoil";


export const CartAtom = atom({
    key: "CartAtom",
    default: [],
});